module.exports = __webpack_public_path__ + "static/media/arrow right.20b2e045.svg";